import React from 'react';
import {
  donViSearchColumns,
  loSearchColumns,
  QUERY_KEYS,
  vatTuSearchColumns,
  viTriSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { DonVi, KhoHang, Lo, VatTu, ViTri } from '@/types/schemas';
import { useSearchFieldsState } from '../../hooks';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  searchFields: ReturnType<typeof useSearchFieldsState>;
}

export const DetailTab: React.FC<DetailTabProps> = ({ searchFields }) => {
  return (
    <div className='space-y-1 p-4'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Mã vật tư</Label>
        <div className='w-full'>
          <SearchField<VatTu>
            type='text'
            displayRelatedField='ten_vt'
            columnDisplay='ma_vt'
            searchEndpoint={`/${QUERY_KEYS.VAT_TU}`}
            searchColumns={vatTuSearchColumns}
            dialogTitle='Danh mục vật tư'
            value={searchFields.selectedMaterial?.ma_vt}
            relatedFieldValue={searchFields.selectedMaterial?.ten_vt}
            onRowSelection={searchFields.setSelectedMaterial}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Mã kho nhập</Label>
        <div className='w-full'>
          <SearchField<KhoHang>
            type='text'
            displayRelatedField='ten_kho'
            columnDisplay='ma_kho'
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}`}
            searchColumns={warehouseSearchColumns}
            dialogTitle='Danh mục kho hàng'
            value={searchFields.selectedImportWarehouse?.ma_kho}
            relatedFieldValue={searchFields.selectedImportWarehouse?.ten_kho}
            onRowSelection={searchFields.setSelectedImportWarehouse}
          />
        </div>
      </div>

      {/* Từ vị trí - From Position Search Field */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Từ vị trí</Label>
        <div className='w-full'>
          <SearchField<ViTri>
            type='text'
            displayRelatedField='ten_vi_tri'
            columnDisplay='ma_vi_tri'
            searchEndpoint={`/${QUERY_KEYS.VI_TRI}`}
            searchColumns={viTriSearchColumns}
            dialogTitle='Danh mục vị trí'
            value={searchFields.selectedFromPosition?.ma_vi_tri}
            relatedFieldValue={searchFields.selectedFromPosition?.ten_vi_tri}
            onRowSelection={searchFields.setSelectedFromPosition}
          />
        </div>
      </div>

      {/* Đến vị trí - To Position Search Field */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Đến vị trí</Label>
        <div className='w-full'>
          <SearchField<ViTri>
            type='text'
            displayRelatedField='ten_vi_tri'
            columnDisplay='ma_vi_tri'
            searchEndpoint={`/${QUERY_KEYS.VI_TRI}`}
            searchColumns={viTriSearchColumns}
            dialogTitle='Danh mục vị trí'
            value={searchFields.selectedToPosition?.ma_vi_tri}
            relatedFieldValue={searchFields.selectedToPosition?.ten_vi_tri}
            onRowSelection={searchFields.setSelectedToPosition}
          />
        </div>
      </div>

      {/* Mã lô - Lot Search Field */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Mã lô</Label>
        <div className='w-full'>
          <SearchField<Lo>
            type='text'
            displayRelatedField='ten_lo'
            columnDisplay='ma_lo'
            searchEndpoint={`/${QUERY_KEYS.LO}`}
            searchColumns={loSearchColumns}
            dialogTitle='Danh mục lô'
            value={searchFields.selectedLot?.ma_lo}
            relatedFieldValue={searchFields.selectedLot?.ten_lo}
            onRowSelection={searchFields.setSelectedLot}
          />
        </div>
      </div>

      <div className='my-3 border-t border-gray-200'></div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Đơn vị</Label>
        <div className='w-full'>
          <SearchField<DonVi>
            type='text'
            displayRelatedField='ten_don_vi'
            columnDisplay='ma_don_vi'
            searchEndpoint={`/${QUERY_KEYS.DON_VI}`}
            searchColumns={donViSearchColumns}
            dialogTitle='Danh mục đơn vị tính'
            value={searchFields.selectedUnit?.ma_unit}
            relatedFieldValue={searchFields.selectedUnit?.ten_don_vi}
            onRowSelection={searchFields.setSelectedUnit}
          />
        </div>
      </div>

      {/* Trạng thái - Status Dropdown */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Trạng thái</Label>
        <div className='flex-1'>
          <FormField
            className='w-[200px]'
            type='select'
            name='status'
            options={[
              { label: 'Tất cả', value: 'ALL' },
              { label: 'Lập chứng từ', value: '0' },
              { label: 'Chờ duyệt', value: '3' },
              { label: 'Xuất kho', value: '5' },
              { label: 'Đang thực hiện', value: '6' },
              { label: 'Hoàn thành', value: '7' },
              { label: 'Hủy', value: '9' }
            ]}
          />
        </div>
      </div>

      {/* Lọc theo người sử dụng - Filter by User Dropdown */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Lọc theo người sd</Label>
        <div className='flex-1'>
          <FormField
            className='w-[200px]'
            type='select'
            name='user_id0'
            options={[
              { label: 'Tất cả', value: 'ALL' },
              { label: 'Lọc theo người tạo', value: '1' }
            ]}
          />
        </div>
      </div>
    </div>
  );
};
